const { first } = require("lodash");
const flickity = require("./flickity-things/flickity.pkgd.js");
require("flickity-bg-lazyload");

module.exports = {
    options: (carousel, autoplay, initialIndex = 0) => {
        return {
            // draggable: false,
            dragThreshold: 50,
            // contain: true,
            wrapAround: true,
            freeScroll: /*window.innerWidth > 576 ? true : */ false,
            lazyLoad: 1,
            adaptiveHeight: autoplay ? true : false,
            autoPlay: autoplay,
            groupCells: 1,
            pauseAutoPlayOnHover: false,
            prevNextButtons:
                carousel.find(".carousel-cell").length > 1 ? true : false,
            // pageDots: autoplay ? true : false,
            pageDots: carousel.find(".carousel-cell").length > 1 ? true : false,
            initialIndex: initialIndex,
            resize: false,
            bgLazyLoad: true,
            on: {
                ready: function () {
                    if (autoplay) {
                        $(".flickity-page-dots .dot").html(
                            '<div class="circle"><div class="halfclip"><div class="halfcircle clipped"></div></div><div class="halfcircle fixed"></div></div>'
                        );
                    }
                    if (autoplay == false) {
                        let cells = carousel.find(".carousel-cell");
                        for (let i = 0; i < cells.length; i++) {
                            $(cells[i])
                                .find(".carousel-cell-numbers")
                                .html(i + 1 + "/" + cells.length);
                            if (carousel[0].offsetParent.id === "vehicules") {
                                $(cells[i]).addClass("h-100");
                            }
                        }
                    }
                    const firstCarousel = document.querySelectorAll(
                        ".component-carousel"
                    );
                    if (firstCarousel.length > 0) {
                        firstCarousel[0]
                            .querySelectorAll(".img")[0]
                            .removeAttribute("style");
                        firstCarousel[0]
                            .querySelectorAll(".carousel-cell-image")[0]
                            .removeAttribute("style");
                    }
                },
                change: function (index) {
                    $(".carousel-cell .collapse").fadeOut("fast");

                    setTimeout(() => {
                        $(".carousel-cell .collapse")
                            .collapse("hide")
                            .removeAttr("style");
                    }, 750);
                },
            },
        };
    },
    init: function (carousel, optionAutoplay = 7000) {
        let $carousel = $(carousel),
            carouselOptions = this.options($carousel, optionAutoplay);
        if ($carousel.length > 0) {
            new flickity($carousel.get(0), carouselOptions);
        }

        $(".main-carousel .collapse").on(
            "shown.bs.collapse hidden.bs.collapse",
            function () {
                $carousel.flickity(carouselOptions);
                let newHeight = $(".carousel-cell.is-selected").height();
                $(".flickity-viewport").height(newHeight);
            }
        );
    },
};
